// return node of given selection matching with dataItem
export default ({
  selection,
  data
}) => {
  return selection.filter(d => {
    return d === data
  }).node()
}



/** WEBPACK FOOTER **
 ** ./src/utils/d3/get_node_from_selection.js
 **/